module.exports = __webpack_public_path__ + "img/LogoBlue.b9331b9d.png";